<script>
import Sortable from "sortablejs";

const createSortable = (el, options) => {
  return Sortable.create(el, {
    ...options,
    onEnd: function(evt) {
      options.onChange(evt);
    }
  });
};

const sortable = {
  name: "sortable",

  bind(el, binding, vnode) {
    const table = el.querySelector("table");
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },

  update(el, binding, vnode) {
    const table = el.querySelector("table");
    table._sortable.destroy();
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },

  unbind(el) {
    const table = el.querySelector("table");
    table._sortable.destroy();
  }
};

export default sortable;
</script>
